// extracted by mini-css-extract-plugin
export default {"msgStyle":"style_msgStyle__dxc3N","title1":"style_title1__QtGQj","title2":"style_title2__e8uYG","title3":"style_title3__jTmGU"};